module.exports = __webpack_public_path__ + "img/lodo-itc.9a149c58.png";